import { Link } from "react-router";

import type { CrossedField } from "@/features/profile/reviewFlags";

/**
 * The fields HR crossed, each with HR's note and a link to the page of the
 * sign-up form where it is put right.
 */
export function CrossedFieldList({ fields }: { fields: readonly CrossedField[] }) {
  return (
    <ul className="mt-1.5 space-y-1.5">
      {fields.map((field) => (
        <li key={field.field}>
          <Link
            to={`/onboarding/${field.stepKey}`}
            className="font-semibold underline underline-offset-2 hover:no-underline"
          >
            {field.label}
          </Link>
          {field.note ? <span>: {field.note}</span> : null}
          {field.changed ? <span className="text-fg-subtle"> (changed)</span> : null}
        </li>
      ))}
    </ul>
  );
}
